import styled from 'styled-components';
import { colors } from 'styles/colors';
import { Circle, MonthContainer } from 'pages/NewOverview/components/GraphTooltip/styles';

export const ConsumptionContainer = styled(MonthContainer)`
  & > span:last-child {
    margin-left: auto;
    font-variant-numeric: tabular-nums;
  }
`;

export const BlueCircle = styled(Circle)`
  background-color: ${colors.bg['primary-base']};
`;
